import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useLocaleRouter } from '@/hooks/useLocaleRouter';
import type { JournalPost } from './types';
import { Title, Text } from '@/components/ui/Headings';

export interface JournalPostCardProps {
  post: JournalPost;
}

const JournalPostCard: React.FC<JournalPostCardProps> = ({ post }) => {
  const { createLocalizedPath } = useLocaleRouter();
  
  return (
    <Link 
      href={createLocalizedPath(`/journal/${post.slug}`)}
      className="block group cursor-pointer"
    >
      <article className="group cursor-pointer">
        <div className="relative overflow-hidden rounded-xl mb-3 h-28 sm:h-32">
          <Image
            src={post.image}
            alt={post.title}
            fill
            className="object-cover transform group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <span className="text-sm text-primary-600 font-medium">{post.readTime}</span>
        <div className="relative mb-1.5 overflow-hidden">
          <Title size="sm" className="group-hover:text-primary-700 transition-colors whitespace-nowrap">
            {post.title}
          </Title>
          <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
        </div>
        <Text variant="body" className="text-gray-600 leading-relaxed">{post.excerpt}</Text>
      </article>
    </Link>
  );
};

export default JournalPostCard;


